import React from "react";
import { Button } from "@mui/material";

const Home = () => {
  return (
    <div className="home-page">
      <Button href="/countries" variant="contained">
        Press Here
      </Button>
    </div>
  );
};

export default Home;
